/**
 * SSO Error Codes
 * Mirrors server-side ErrorCodes.java and ErrorCodesEnum.java
 * Used across action creators for consistent error handling.
 */
import { getLabelFromJspVariables } from './JspUtil';

// Authentication & Authorization
export const ERR_GENERAL = -32000;
export const ERR_PLEASE_LOGIN = -32002;
export const ERR_REQUIRES_ADMIN_ROLE = -32003;
export const ERR_DUPLICATE_USER = -32004;
export const ERR_INVALID_USER_NAME = -32005;
export const ERR_INVALID_PASSWORD_FORMAT = -32006;
export const ERR_INVALID_OLD_PASSWORD = -32007;
export const ERR_PASSWORD_EXPIRED = -32008;
export const ERR_ACCOUNT_LOCKED = -32010;
export const ERR_PASSWORD_REUSED = -32011;
export const ERR_INVALID_APP = -32014;

// User Linking
export const ERR_USER_PRIMARY_ALREADY_LINKED_TO_SECONDARY_APP = -32017;

// Password
export const ERR_WEAK_PASSWORD = -32028;
export const ERR_APIUSER_TEMP_PASSWORD_EXPIRED = -32029;
export const ERR_TEMP_PASSWORD_EXPIRED = -32030;
export const ERR_USER_NEEDS_TO_SELECT_APP = -32032;
export const ERR_PASSWORD_RECENTLY_CHANGED = -32340;
export const ERR_INVALID_ARGS = -32602;

// Session Management
export const ERR_USER_EXCEED_MAX_SESSIONS = -32031;
export const ERR_USER_HAS_EXISTING_SESSIONS = -32033;

// TFA (Two-Factor Authentication)
export const ERR_REQUIRES_TFA = -32100;
export const ERR_TFA_SETUP_INCOMPLETE = -32102;
export const ERR_TFA_MISSING_INFO = -32105;
export const ERR_TFA_NOT_ENABLED = -32106;
export const ERR_TFA_MISSING_EMAIL_VERIFY = -32107;
export const ERR_2FA_IS_DISABLED = -32110;
export const ERR_2FA_EMAIL_INVALID = -32111;
export const ERR_2FA_NOT_REGISTERED = -32112;
export const ERR_TFA_OTP_ALREADY_USED = -32118;
export const ERR_EULA_REQUIRED = -32121;
export const ERR_REQUIRES_OTP_ENTERED_AUTH = -32320;

// Global ID
export const ERR_NON_CONFIRMED_GLOBAL_ID = -32310;
export const ERR_GLOBAL_ID_EMAIL_CANNOT_BE_CHANGED = -32350;

// Global ID Transition
export const ERR_TRANSITION_TO_GLOBAL_GLOBAL_ID_PRESENT = -32800;
export const ERR_TRANSITION_TO_GLOBAL_GLOBAL_ID_PRESENT_NOT_VERIFIED = -32810;
export const ERR_TRANSITION_TO_GLOBAL_GLOBAL_ID_PRESENT_NOT_LINKED_TO_APP_ID = -32815;
export const ERR_TRANSITION_TO_GLOBAL_GLOBAL_ID_PRESENT_APP_ID_ATTEMPTS_EXCEEDED = -32830;
export const ERR_TRANSITION_TO_GLOBAL_GLOBAL_ID_NOT_PRESENT_APP_ID_2FA_VERIFIED = -32840;
export const ERR_TRANSITION_TO_GLOBAL_GLOBAL_ID_NOT_PRESENT_APP_ID_2FA_VERIFIED_LINK_FAILED = -32841;
export const ERR_TRANSITION_TO_GLOBAL_GLOBAL_ID_NOT_PRESENT_APP_ID_2FA_NOT_ENABLED = -32860;

// Password-less Login
export const ERR_PASSWORD_LESS_REQUIRES_SAML_REDIRECT = -36100;
export const ERR_PASSWORD_LESS_REQUIRES_OTP = -36200;
export const ERR_PASSWORD_LESS_OTP_FLOW = -36208;

// Email Verification
export const ERR_EMAIL_VERIFICATION_CODE_INVALID = -33110;
export const ERR_EMAIL_VERIFICATION_INVALID_SESSION = -33116;

// Registration
export const ERR_USER_REGISTRATION_EXISTS = -38002;
export const ERR_OPEN_REGISTRATION_EXISTS = -38003;

// Password Pwned
export const ERR_PASSWORD_PWNED = -33102;

// WebAuthn Client Errors (browser-side, not server codes)
export const WEBAUTHN_USER_CANCELLED = 0;
export const WEBAUTHN_DEVICE_ALREADY_REGISTERED = 11;

// --- Client-side validation messages ---
// Lazy getters: these resolve the label from the DOM (#app-strings) at CALL time.
// They must not be eager constants — this module can be imported before the
// #app-strings block exists, which would freeze the value to the raw key.
export const MSG_FIELD_REQUIRED = () => getLabelFromJspVariables('alert_field_required');
export const MSG_EMAIL_REQUIRED = () => getLabelFromJspVariables('alert_email_required');
export const MSG_FIRST_NAME_REQUIRED = () => getLabelFromJspVariables('alert_first_name_required');
export const MSG_LAST_NAME_REQUIRED = () => getLabelFromJspVariables('alert_last_name_required');
export const MSG_PASSWORD_REQUIRED = () => getLabelFromJspVariables('alert_password_required');
export const MSG_CONFIRM_PASSWORD_REQUIRED = () => getLabelFromJspVariables('alert_confirm_password_required');
export const MSG_PASSWORDS_DO_NOT_MATCH = () => getLabelFromJspVariables('alert_passwords_dont_match');
export const MSG_INVALID_EMAIL = () => getLabelFromJspVariables('alert_invalid_email');
export const MSG_CAPTCHA_REQUIRED = () => getLabelFromJspVariables('alert_captcha_required');
export const MSG_STATE_REQUIRED = () => getLabelFromJspVariables('alert_state_required');
export const MSG_ZIP_REQUIRED = () => getLabelFromJspVariables('alert_zip_required');
export const MSG_PHONE_INVALID = () => getLabelFromJspVariables('alert_phone_invalid');
export const MSG_ALT_PHONE_INVALID = () => getLabelFromJspVariables('alert_alt_phone_invalid');
export const MSG_MAX_LENGTH = (len) => getLabelFromJspVariables('alert_max_length', len);
